export default function isOfferExpired(ended_at: Date, now: Date): boolean {
  const end = new Date(ended_at);

  // Set both dates to start of day (midnight) for date-only comparison
  const nowStartOfDay = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
  );
  const endStartOfDay = new Date(
    end.getFullYear(),
    end.getMonth(),
    end.getDate(),
  );

  // Offer is expired only if end date is BEFORE today (not including today)
  const isOfferExpired = endStartOfDay.getTime() < nowStartOfDay.getTime();
  return isOfferExpired;
}
